/* eslint-disable sonarjs/no-identical-functions */
import { createReducer, on } from '@ngrx/store';
import * as validatorReducerUtil from './util/validate-reducer.util';
import * as fromActions from './app.actions';
import { AppStateRoot } from './app.model';

export const initialState: AppStateRoot = {
  detailsLoaded: true,
  detailsError: undefined,
  additionalDetailCode: '0',
  agencyList: [],
  isPostAffirmFailed: false,
  isGetAgencyListFailed: false,
  affirmResponse: '',
  agencyResponse: {
    user_info: {
      id: '',
      first_name: '',
      contact_id: '',
    },
    agencies: [
      {
        id: '',
        name: '',
        correspondence_address: '',
      },
      {
        id: '',
        name: '',
        correspondence_address: '',
      },
    ],
    show_affirmation_popup: '',
  },
};
export const APP_FEATURE_KEY = 'App';
export interface AppStatePartialState {
  readonly [APP_FEATURE_KEY]: AppStateRoot;
}
export const appReducer = createReducer(
  initialState,

  on(fromActions.getAgencyList, (state, _action) => ({
    ...state,
    detailsLoaded: false,
    additionalDetailCode: '0',
    detailsError: undefined,
    agencyListError: undefined,
    isGetAgencyListFailed: false,
  })),
  on(fromActions.getAgencyListSuccess, (state, { payload }) => ({
    ...state,
    agencyList: payload.response.agencies,
    agencyResponse: payload.response,
    detailsLoaded: true,
    detailsError: undefined,
    agencyListError: undefined,
    isGetAgencyListFailed: false,
  })),
  on(fromActions.getAgencyListFailure, (state, { error }) => ({
    ...state,
    detailsLoaded: true,
    agencyList: initialState.agencyList,
    detailsError: error,
    agencyListError: error,
    isGetAgencyListFailed: true,
  })),
  on(fromActions.postAffirm, (state, _action) => ({
    ...state,
    detailsLoaded: false,
    isPostAffirmFailed: false,
    additionalDetailCode: '0',
    detailsError: undefined,
    affirmResponse: '',
  })),
  on(fromActions.postAffirmSuccess, (state, { payload }) => ({
    ...state,
    isPostAffirmFailed: false,
    additionalDetailCode: validatorReducerUtil.extractAdditionalDetails(
      payload.metadata,
    ),
    detailsLoaded: true,
    detailsError: undefined,
    affirmResponse: payload.response.status,
  })),

  on(fromActions.postAffirmFailure, (state, { error }) => ({
    ...state,
    detailsLoaded: true,
    isPostAffirmFailed: true,
    additionalDetailCode:
      error.status !== 500
        ? validatorReducerUtil.extractAdditionalDetails(
            error.errObject.metadata,
          )
        : error.status.toString(),
    detailsError: error,
    affirmResponse: '',
  })),
  on(fromActions.getKeepAlive, (state, _action) => ({
    ...state,
    detailsLoaded: false,
    additionalDetailCode: '0',
    detailsError: undefined,
  })),
  on(fromActions.getKeepAliveSuccess, (state) => ({
    ...state,
    detailsLoaded: true,
    detailsError: undefined,
  })),
  on(fromActions.getKeepAliveFailure, (state, { error }) => ({
    ...state,
    detailsLoaded: true,
    detailsError: error,
  })),
);
